// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"80b92a5a","554":"f99228f9","590":"aa88df80","686":"b284379c"}[chunkId] + ".chunk.css";
};